"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8190],{

/***/ 8190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ LogoGallery; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-d6406817.mjs
var Image_d6406817 = __webpack_require__(5905);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-479ac100.mjs
var Link_479ac100 = __webpack_require__(965);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/LogoGallery.js








const L = "logo-gallery__content", _ = "logo-gallery__header", u = "logo-gallery__lead", p = "logo-gallery__list", E = "logo-gallery__list-container", I = "logo-gallery__item", h = "logo-gallery__item--link", k = "logo-gallery__image", o = {
  logoGalleryContent: L,
  logoGalleryHeader: _,
  logoGalleryLead: u,
  logoGalleryList: p,
  logoGalleryListContainer: E,
  logoGalleryItem: I,
  logoGalleryItemLink: h,
  logoGalleryImage: k
}, N = [];
function $({
  header: r,
  leadText: e,
  logos: l = N
}) {
  const [a, n] = (0,react.useState)(() => l);
  return (0,react.useEffect)(() => {
    n(C(l));
  }, [l]), !r && !e && a.length === 0 ? null : /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      as: "section",
      topPadding: Block_9b78bd10.B.Padding.SMALL,
      bottomPadding: Block_9b78bd10.B.Padding.LARGE,
      "data-testid": "logo-gallery"
    },
    /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { flex: !0, className: o.logoGalleryContent }, r && /* @__PURE__ */ react.createElement(
      "h2",
      {
        className: (0,app_a75c1d35.c)(
          app_a75c1d35.t.headingSection,
          o.logoGalleryHeader
        ),
        "data-testid": "logo-gallery-header"
      },
      r
    ), e && /* @__PURE__ */ react.createElement(
      "p",
      {
        className: (0,app_a75c1d35.c)(app_a75c1d35.t.textsLeadText, o.logoGalleryLead),
        "data-testid": "logo-gallery-lead"
      },
      e
    ), a.length > 0 && /* @__PURE__ */ react.createElement("div", { className: o.logoGalleryListContainer }, /* @__PURE__ */ react.createElement(
      "ul",
      {
        className: o.logoGalleryList,
        "data-testid": "logo-gallery-list"
      },
      a.map((g, c) => /* @__PURE__ */ react.createElement("li", { key: `${g.href ?? "logo"}-${g.image.src}-${c}` }, /* @__PURE__ */ react.createElement(x, { item: g })))
    )))
  );
}
function x({ item: r }) {
  const { image: e, href: l, isExternalLink: a } = r, n = /* @__PURE__ */ react.createElement(
    Image_d6406817.I,
    {
      ...e,
      className: o.logoGalleryImage,
      altText: e.altText
    }
  );
  return l ? /* @__PURE__ */ react.createElement(
    Link_479ac100.L,
    {
      href: l,
      target: a ? "_blank" : void 0,
      disableLinkTextStyle: !0,
      className: (0,app_a75c1d35.c)(o.logoGalleryItem, o.logoGalleryItemLink),
      "data-testid": "logo-gallery-item"
    },
    n
  ) : /* @__PURE__ */ react.createElement("div", { className: o.logoGalleryItem, "data-testid": "logo-gallery-item" }, n);
}
function C(r) {
  const e = [...r];
  for (let l = e.length - 1; l > 0; l -= 1) {
    const a = Math.floor(Math.random() * (l + 1)), n = e[l], g = e[a];
    n !== void 0 && g !== void 0 && (e[l] = g, e[a] = n);
  }
  return e;
}

//# sourceMappingURL=LogoGallery.js.map

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/LogoGallery/LogoGallery.tsx









function LogoGallery(props) {
    var isPreview = (0,router.useRouter)().isPreview;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var logos = (0,react.useMemo)(function() {
        return (0,magnolia/* jcrMultiFieldToArray */.FE)(props.logos).map(function(node) {
            return mapLogoNodeToItem(node, imageDataHandler, isPreview);
        });
    }, [
        props.logos,
        imageDataHandler,
        isPreview
    ]);
    if (logos.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)($, {
        header: props.header,
        leadText: props.leadText,
        logos: logos
    });
}
function mapLogoNodeToItem(node, imageDataHandler, isPreview) {
    var ref;
    var image = node.image, altText = node.altText, link = node.link;
    var imageData = imageDataHandler(image, {
        maxViewport: app/* Viewport.sm */.l_.sm
    });
    var ref1 = (0,magnolia/* resolveLinkSwitchableField */.cJ)(link, isPreview), linkHref = ref1.linkHref, isExternalLink = ref1.isExternalLink;
    return {
        image: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
            altText: altText || ((ref = image.metadata) === null || ref === void 0 ? void 0 : ref.title) || "Company logo"
        }),
        href: linkHref || undefined,
        isExternalLink: isExternalLink
    };
}

;// CONCATENATED MODULE: ./src/magnolia/components/LogoGallery/index.ts
/* istanbul ignore file */ 


/***/ })

}]);